/**
 * AlmadarPostStateSyncBrowserTabsSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostStateSyncBrowserTabsSLPostPage
 */

import { useAlmadarPostStateSyncBrowserTabsSLPostPageLogic } from '@/hooks/traits/useAlmadarPostStateSyncBrowserTabsSLPostPageLogic';
import type { AlmadarPostStateSyncBrowserTabsSLPostPageConfig } from '@/hooks/traits/useAlmadarPostStateSyncBrowserTabsSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostStateSyncBrowserTabsSLPostView as AlmadarPostStateSyncBrowserTabsSLPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostStateSyncBrowserTabsSLPostFooterView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsSLPostFooterView';
import { AlmadarPostStateSyncBrowserTabsSLPostHeaderView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsSLPostHeaderView';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostStateSyncBrowserTabsSLPostView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsSLPostView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostStateSyncBrowserTabsSLPostPageViewProps {
  config?: Partial<AlmadarPostStateSyncBrowserTabsSLPostPageConfig>;
}

export function AlmadarPostStateSyncBrowserTabsSLPostPageView({ config: propsConfig }: AlmadarPostStateSyncBrowserTabsSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostStateSyncBrowserTabsSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostStateSyncBrowserTabsSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostStateSyncBrowserTabsSL" trait="AlmadarPostStateSyncBrowserTabsSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostStateSyncBrowserTabsSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostStateSyncBrowserTabsSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} paddingY="xl" bg="transparent"><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostStateSyncBrowserTabsSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostStateSyncBrowserTabsSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostStateSyncBrowserTabsSLPostPageView;
